import { useEffect, useState } from "react";
import { CustomTabs } from "./CustomTabs";
import { AddSubLessonContent } from "./AddSubLessonContent";
import { delete_SubLesson, delete_SubLessonContent, delete_SubLessonVideo, getContentBySubLesson, getSubLessonOrder, getVideoBySubLesson } from "../services/SubLesson";
import DOMPurify from 'dompurify';
import { AddSubLessonVideo } from "./AddSubLessonVideo";
import { EditSubLessonContent } from "./EditSubLessonContent";
import useDelete from "../hook/useDelete";
import useAuth from "../hook/useAuth";
import DeletePopup from "./DeletePopup";
import { EditSubLessonVideo } from "./EditSubLessonVideo";
import { SubLessonOrder } from "./SubLessonOrder";
import { delete_Quiz, getQuizeBySubLesson } from "../services/Quize";
import { AddQuize } from "./AddQuize";
import { EditQuize } from "./EditQuize";
import { AddPractice } from "./AddPractice";
import { delete_Practice, getPracticeBySubLesson } from "../services/Practice";
import { EditPractice } from "./EditPractice";
import { AddImageFile } from "./AddImageFile";
import { delete_SubLessonfileUpload, getSubLessonFileUploads } from "../services/FileUpload";
import baseURL from "../config/api";
import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { ImagePreview } from "./ImagePreview";
import { ConfirmPopup } from "./ConfirmPopup";


type SubLessonProps = {
    key: number;
    data: any;
    setEditSubLesson: (value: any) => void;
    setRefreshSubLessonList: (value: boolean) => void;
    setShowEditSubLessonPopup: (value: boolean) => void;
}

const tabs = ["Content", "Video", "SubLesson Order", "Quiz", "Practice", "Image Files"]

const getYouTubeId = (url: string) => {
    try {
        if (url.includes("youtu.be")) {
            return url.split("youtu.be/")[1].split("?")[0];
        }
        if (url.includes("watch?v=")) {
            return new URL(url).searchParams.get("v");
        }
        if (url.includes("embed/")) {
            return url.split("embed/")[1].split("?")[0];
        }
        return null;
    } catch {
        return null;
    }
};

const getEmbedUrl = (url: string) => {
    const id = getYouTubeId(url);
    return id ? `https://www.youtube.com/embed/${id}?autoplay=1` : url;
};

const getThumbnailUrl = (url: string) => {
    const id = getYouTubeId(url);
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}



export const SubLesson = ({ key, data, setEditSubLesson, setRefreshSubLessonList, setShowEditSubLessonPopup }: SubLessonProps) => {
    const { auth }: any = useAuth();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [contentData, setContentData] = useState<any[]>([]);
    const [contentDataLoaded, setContentDataLoaded] = useState<boolean>(false);
    const [refreshContentList, setRefreshContentList] = useState<boolean>(true);
    const [showAddContentPopup, setShowAddContentPopup] = useState<boolean>(false);
    const [showEditContentPopup, setShowEditContentPopup] = useState<boolean>(false);
    const [editContent, setEditContent] = useState<any>({});
    const [videoData, setVideoData] = useState<any[]>([]);
    const [videoDataLoaded, setVideoDataLoaded] = useState<boolean>(false);
    const [showAddVideoPopup, setShowAddVideoPopup] = useState<boolean>(false);
    const [showEditVideoPopup, setShowEditVideoPopup] = useState<boolean>(false);
    const [ediVideo, setEditVideo] = useState<any>({});
    const [refreshVideoList, setRefreshVideoList] = useState<boolean>(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [allSublessonOrder, setAllSubLessonOrder] = useState<any[]>([]);
    const [subLessonOrderLoaded, setSubLessonOrderLoaded] = useState<boolean>(false);
    const [quizeData, setQuizeData] = useState<any[]>([]);
    const [quizeDataLoaded, setQuizeDataLoaded] = useState<boolean>(false);
    const [showAddQuizePopup, setShowAddQuizePopup] = useState<boolean>(false);
    const [showEditQuizePopup, setShowEditQuizePopup] = useState<boolean>(false);
    const [editQuize, setEditQuize] = useState<any>({});
    const [refreshQuizeList, setRefreshQuizeList] = useState<boolean>(true);
    const [practiceData, setPracticeData] = useState<any[]>([]);
    const [practiceDataLoaded, setPracticeDataLoaded] = useState<boolean>(false);
    const [showAddPracticePopup, setShowAddPracticePopup] = useState<boolean>(false);
    const [showEditPracticePopup, setShowEditPracticePopup] = useState<boolean>(false);
    const [editPractice, setEditPractice] = useState<any>({});
    const [refreshPracticeList, setRefreshPracticeList] = useState<boolean>(true);
    const [imageFileData, setImageFileData] = useState<any[]>([]);
    const [imageFileDataLoaded, setImageFileDataLoaded] = useState<boolean>(false);
    const [showAddImageFilePopup, setShowImageFilePopup] = useState<boolean>(false);
    const [refreshImageFileList, setRefreshImageFileList] = useState<boolean>(true);
    const [showCopySuccess, setShowCopySuccess] = useState<boolean>(false);
    const [showImagePreviewPopup, setShowImagePreviewPopup] = useState<boolean>(false);
    const [imagePath, setImagePath] = useState<string>("")

    useEffect(() => {
        if (data?.id && refreshContentList && activeIndex === 0) {
            setContentDataLoaded(false);
            getContentBySubLesson(data?.id)
                .then((data) => {
                    const purifyRespose = data?.map((item: any) => {
                        return {
                            ...item,
                            lessonContent: DOMPurify.sanitize(item?.lessonContent, {
                                FORBID_TAGS: ['script'],
                                FORBID_ATTR: ['onerror', 'onclick', 'onload']
                            })
                        }
                    })

                    setContentData(purifyRespose);
                    setContentDataLoaded(true);
                    setRefreshContentList(false);
                    setEditContent({});
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [data, refreshContentList, activeIndex])

    useEffect(() => {
        if (data?.id && refreshVideoList && activeIndex === 1) {
            setVideoDataLoaded(false);
            getVideoBySubLesson(data?.id)
                .then((data) => {
                    setVideoData(data);
                    setVideoDataLoaded(true);
                    setRefreshVideoList(false);
                    setEditVideo({});
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [data, refreshVideoList, activeIndex])


    useEffect(() => {
        if (data?.id && activeIndex === 2) {
            setSubLessonOrderLoaded(false);
            getSubLessonOrder(data?.id)
                .then((data) => {
                    setAllSubLessonOrder(data);
                    setSubLessonOrderLoaded(true);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [data, activeIndex])


    useEffect(() => {
        if (data?.id && refreshQuizeList && activeIndex === 3) {
            setQuizeDataLoaded(false);
            getQuizeBySubLesson(data?.id)
                .then((data) => {
                    setQuizeData(data);
                    setQuizeDataLoaded(true);
                    setRefreshQuizeList(false);
                    setEditQuize({});
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [data, refreshQuizeList, activeIndex])

    useEffect(() => {
        if (data?.id && refreshPracticeList && activeIndex === 4) {
            setPracticeDataLoaded(false);
            getPracticeBySubLesson(data?.id)
                .then((data) => {
                    setPracticeData(data);
                    setPracticeDataLoaded(true);
                    setRefreshPracticeList(false);
                    setEditQuize({});
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [data, refreshPracticeList, activeIndex])


    useEffect(() => {
        if (data?.id && refreshImageFileList && activeIndex === 5) {
            setImageFileDataLoaded(false);
            getSubLessonFileUploads("SubLessonFile", data?.id)
                .then((data) => {
                    setImageFileData(data);
                    setImageFileDataLoaded(true);
                    setRefreshImageFileList(false);

                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [data, refreshImageFileList, activeIndex])

    const hanbleTabChange = (index: number) => {
        setActiveIndex(index);
        if (index === 0) {
            setRefreshContentList(true);
        }
        else if (index === 1) {
            setRefreshVideoList(true)
        }
        else if (index === 3) {
            setRefreshQuizeList(true)
        }
        else if (index === 4) {
            setRefreshPracticeList(true)
        }
        else if (index === 5) {
            setRefreshImageFileList(true);
        }
    }

    const handleCopyFileUrl = async (fileUrl: string) => {
        try {
            await navigator.clipboard.writeText(fileUrl);
            setShowCopySuccess(true);

        } catch (err) {
            console.error("Failed to copy: ", err);
            setShowCopySuccess(false);
        }
    }

    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }

        setShowCopySuccess(false);
    };

    const handleOnDeleteContent = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this content?`,
                isDelete: (callback: any) => {
                    delete_SubLessonContent(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshContentList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }

    const handleOnDeleteVideo = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this video?`,
                isDelete: (callback: any) => {
                    delete_SubLessonVideo(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshVideoList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }

    const handleOnDeleteSubLesson = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this sub-lesson?`,
                isDelete: (callback: any) => {
                    delete_SubLesson(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshSubLessonList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }

    const handleOnDeleteQuiz = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this quiz?`,
                isDelete: (callback: any) => {
                    delete_Quiz(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshQuizeList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }

    const handleOnDeletePractice = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this practice?`,
                isDelete: (callback: any) => {
                    delete_Practice(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshPracticeList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }

    const handleOnDeleteImageFile = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this file?`,
                isDelete: (callback: any) => {
                    delete_SubLessonfileUpload(id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshImageFileList(true);
                            callback();
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }

    return (
        <>
            <div key={key} className="w-full bg-white rounded-xl shadow p-6 mb-6">
                {/* Header */}
                <div className="w-full flex items-center justify-between">
                    <h2 className="text-lg font-semibold text-gray-800 mb-4">{data?.title}</h2>
                    <div className="flex items-center gap-2.5">
                        <button
                            className="text-primary hover:text-blue-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                            onClick={() => {
                                setEditSubLesson(data);
                                setShowEditSubLessonPopup(true);
                            }}
                        >
                            <span className="material-symbols-outlined text-xl">edit</span>
                        </button>
                        <button
                            className="text-red-500 hover:text-red-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                            onClick={() => handleOnDeleteSubLesson(data?.id)}
                        >
                            <span className="material-symbols-outlined text-xl">delete</span>
                        </button>
                    </div>
                </div>

                <div className="w-full py-4">
                    <CustomTabs
                        tabs={tabs}
                        activeIndex={activeIndex}
                        onChange={(index) => hanbleTabChange(index)}
                    />

                </div>

                {/* Tab Panels */}
                {
                    activeIndex === 0 && (
                        <div className="w-full px-4">
                            <div className="w-full mt-4 mb-4 flex justify-end items-center pb-4 border-b border-gray-200">
                                <button
                                    className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                    onClick={() => setShowAddContentPopup(true)}
                                >
                                    Add content
                                </button>
                            </div>

                            {
                                (contentDataLoaded && contentData.length > 0) && (
                                    <div className="w-full space-y-4">
                                        {
                                            contentData.sort((a: any, b: any) => a.orderNumber - b.orderNumber).map((item: any, index: number) => (
                                                <div key={index} className="w-full p-2 shadow-sm rounded-md border border-gray-200">
                                                    <div className="w-full flex items-center justify-between">
                                                        <h2 className="text-lg font-semibold text-gray-800 mb-4">{item?.title}</h2>
                                                        <div className="flex items-center gap-2.5">
                                                            <button
                                                                className="text-primary hover:text-blue-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                                onClick={() => {
                                                                    setEditContent(item);
                                                                    setShowEditContentPopup(true);
                                                                }}
                                                            >
                                                                <span className="material-symbols-outlined text-xl">edit</span>
                                                            </button>
                                                            <button
                                                                className="text-red-500 hover:text-red-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                                onClick={() => handleOnDeleteContent(item?.id)}
                                                            >
                                                                <span className="material-symbols-outlined text-xl">delete</span>
                                                            </button>
                                                        </div>
                                                    </div>


                                                    <div className="sanitized-content w-full py-2 text-gray-800 whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: item?.lessonContent }} />
                                                </div>
                                            ))
                                        }
                                    </div>


                                )
                            }

                            {
                                !contentDataLoaded && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }


                            {
                                (contentDataLoaded && contentData.length === 0) && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <span className="text-lg text-gray-400">No content found!</span>
                                    </div>
                                )
                            }


                        </div>
                    )
                }

                {
                    activeIndex === 1 && (
                        <div className="w-full px-4">
                            <div className="w-full mt-4 mb-4 flex justify-end items-center pb-4 border-b border-gray-200">
                                <button
                                    className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                    onClick={() => setShowAddVideoPopup(true)}
                                >
                                    Add video
                                </button>
                            </div>

                            {
                                (videoDataLoaded && videoData.length > 0) && (
                                    <div className="w-full space-y-4">
                                        {
                                            videoData.sort((a: any, b: any) => a.orderNumber - b.orderNumber).map((item: any, index: number) => (
                                                <div key={index} className="w-full p-2 shadow-sm rounded-md border border-gray-200">
                                                    <div className="w-full flex items-center justify-between">
                                                        <h2 className="text-lg font-semibold text-gray-800 mb-4">{item?.title}</h2>
                                                        <div className="flex items-center gap-2.5">
                                                            <button
                                                                className="text-primary hover:text-blue-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                                onClick={() => {
                                                                    setEditVideo(item);
                                                                    setShowEditVideoPopup(true);
                                                                }}
                                                            >
                                                                <span className="material-symbols-outlined text-xl">edit</span>
                                                            </button>
                                                            <button
                                                                className="text-red-500 hover:text-red-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                                onClick={() => handleOnDeleteVideo(item?.id)}
                                                            >
                                                                <span className="material-symbols-outlined text-xl">delete</span>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="w-full h-96 mb-3 relative mt-2">
                                                        {!isPlaying ? (
                                                            <div
                                                                className="w-full h-full relative cursor-pointer group"
                                                                onClick={() => setIsPlaying(true)}
                                                            >
                                                                <img
                                                                    src={getThumbnailUrl(item?.videoUrl)}
                                                                    alt={item?.title}
                                                                    className="w-full h-full object-cover rounded"
                                                                />

                                                                <div className="absolute inset-0 flex items-center justify-center">
                                                                    <div className="bg-primary rounded-full p-4 transition shadow-lg">
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            className="h-12 w-12 text-white"
                                                                            fill="currentColor"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path d="M8 5v14l11-7z" />
                                                                        </svg>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        ) : (
                                                            <iframe
                                                                src={getEmbedUrl(item?.videoUrl)}
                                                                title={item?.title}
                                                                className="w-full h-full rounded"
                                                                allow="autoplay; encrypted-media"
                                                                allowFullScreen
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>


                                )
                            }

                            {
                                !videoDataLoaded && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }


                            {
                                (videoDataLoaded && videoData.length === 0) && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <span className="text-lg text-gray-400">No video found!</span>
                                    </div>
                                )
                            }


                        </div>
                    )
                }

                {
                    activeIndex === 2 && (
                        <div className="w-full px-4">

                            {
                                (subLessonOrderLoaded && allSublessonOrder.length > 0) && (
                                    <SubLessonOrder subLessonData={allSublessonOrder} />
                                )
                            }


                            {
                                !subLessonOrderLoaded && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }


                            {
                                (subLessonOrderLoaded && allSublessonOrder.length === 0) && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <span className="text-lg text-gray-400">No data found!</span>
                                    </div>
                                )
                            }
                        </div>
                    )
                }

                {
                    activeIndex === 3 && (
                        <div className="w-full px-4">
                            <div className="w-full mt-4 mb-4 flex justify-end items-center pb-4 border-b border-gray-200">
                                <button
                                    className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                    onClick={() => setShowAddQuizePopup(true)}
                                >
                                    Add quiz
                                </button>
                            </div>

                            {
                                (quizeDataLoaded && quizeData.length > 0) && (
                                    quizeData.map((quiz: any, index: number) => (
                                        <div
                                            key={index}
                                            className="p-4 border rounded mb-2 flex justify-between items-center bg-white"
                                        >
                                            <div>
                                                <h3 className="font-semibold">{quiz.title}</h3>
                                                <p className="text-gray-600 text-sm">{quiz.description}</p>
                                            </div>
                                            <div className="flex gap-2">
                                                <button
                                                    className="text-primary hover:text-blue-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                    onClick={() => {
                                                        setEditQuize(quiz);
                                                        setShowEditQuizePopup(true);
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined text-xl">edit</span>
                                                </button>
                                                <button
                                                    className="text-red-500 hover:text-red-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                    onClick={() => handleOnDeleteQuiz(quiz?.id)}
                                                >
                                                    <span className="material-symbols-outlined text-xl">delete</span>
                                                </button>

                                            </div>
                                        </div>
                                    ))
                                )
                            }

                            {
                                !quizeDataLoaded && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }

                            {
                                (quizeDataLoaded && quizeData.length === 0) && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <span className="text-lg text-gray-400">No quiz found!</span>
                                    </div>
                                )
                            }
                        </div>
                    )}

                {
                    activeIndex === 4 && (
                        <div className="w-full px-4">
                            <div className="w-full mt-4 mb-4 flex justify-end items-center pb-4 border-b border-gray-200">
                                <button
                                    className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                    onClick={() => setShowAddPracticePopup(true)}
                                >
                                    Add practice
                                </button>
                            </div>

                            {
                                (practiceDataLoaded && practiceData.length > 0) && (
                                    practiceData.map((ex: any, index: number) => (
                                        <div
                                            key={index}
                                            className="p-4 border rounded mb-2 flex justify-between items-center bg-white"
                                        >
                                            <div>
                                                <h3 className="font-semibold">{ex.title}</h3>
                                                <p className="text-gray-600 text-sm">{ex.description}</p>
                                            </div>
                                            <div className="flex gap-2">
                                                <button
                                                    className="text-primary hover:text-blue-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                    onClick={() => {
                                                        setEditPractice(ex);
                                                        setShowEditPracticePopup(true);
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined text-xl">edit</span>
                                                </button>
                                                <button
                                                    className="text-red-500 hover:text-red-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8"
                                                    onClick={() => handleOnDeletePractice(ex?.id)}
                                                >
                                                    <span className="material-symbols-outlined text-xl">delete</span>
                                                </button>

                                            </div>
                                        </div>
                                    ))
                                )
                            }

                            {
                                !practiceDataLoaded && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }

                            {
                                (practiceDataLoaded && practiceData.length === 0) && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <span className="text-lg text-gray-400">No practice found!</span>
                                    </div>
                                )
                            }
                        </div>
                    )}

                {
                    activeIndex === 5 && (
                        <div className="w-full px-4">
                            <div className="w-full mt-4 mb-4 flex justify-end items-center pb-4 border-b border-gray-200">
                                <button
                                    className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                    onClick={() => setShowImageFilePopup(true)}
                                >
                                    Upload
                                </button>
                            </div>

                            {
                                (imageFileDataLoaded && imageFileData.length > 0) && (
                                    imageFileData.map((image: any, index: number) => (
                                        <div
                                            key={index}
                                            className="p-4 border rounded mb-2 flex flex-col gap-3 md:gap-1.5 md:flex-row md:justify-between md:items-center bg-white"
                                        >
                                            {/* URL Text */}
                                            <div className="w-full md:w-auto">
                                                <p className="text-gray-600 text-sm break-all">
                                                    {`${baseURL}commonFile/Get?name=${image?.fileName}`}
                                                </p>
                                            </div>

                                            {/* Action Buttons */}
                                            <div className="flex gap-2 justify-end flex-wrap">
                                                <button
                                                    className="text-primary hover:text-blue-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center"
                                                    onClick={() => {
                                                        setShowImagePreviewPopup(true);
                                                        setImagePath(`${baseURL}commonFile/Get?name=${image?.fileName}`);
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined text-xl">visibility</span>
                                                </button>

                                                <button
                                                    className="text-primary hover:text-blue-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center"
                                                    onClick={() =>
                                                        handleCopyFileUrl(`${baseURL}commonFile/Get?name=${image?.fileName}`)
                                                    }
                                                >
                                                    <span className="material-symbols-outlined text-xl">file_copy</span>
                                                </button>

                                                <button
                                                    className="text-red-500 hover:text-red-600 shadow-sm cursor-pointer border border-[#D0D0D0] hover:bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center"
                                                    onClick={() => handleOnDeleteImageFile(image?.id)}
                                                >
                                                    <span className="material-symbols-outlined text-xl">delete</span>
                                                </button>
                                            </div>
                                        </div>

                                    ))
                                )
                            }

                            {
                                !imageFileDataLoaded && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }

                            {
                                (imageFileDataLoaded && imageFileData.length === 0) && (
                                    <div className="flex items-center justify-center w-full p-2">
                                        <span className="text-lg text-gray-400">No file found!</span>
                                    </div>
                                )
                            }
                        </div>
                    )}

            </div>
            {
                showAddContentPopup && (
                    <AddSubLessonContent showPopup={showAddContentPopup} setShowPopup={setShowAddContentPopup} setRefreshContentList={setRefreshContentList} subLessonId={data?.id} lastContentOrder={contentData[contentData.length - 1]?.orderNumber || 0} />
                )
            }

            {
                showEditContentPopup && (
                    <EditSubLessonContent showPopup={showEditContentPopup} setShowPopup={setShowEditContentPopup} setRefreshContentList={setRefreshContentList} data={editContent} />
                )
            }

            {
                showAddVideoPopup && (
                    <AddSubLessonVideo showPopup={showAddVideoPopup} setShowPopup={setShowAddVideoPopup} setRefreshVideoList={setRefreshVideoList} subLessonId={data?.id} lastVideoOrder={videoData[videoData.length - 1]?.orderNumber || 0} />
                )
            }

            {
                showEditVideoPopup && (
                    <EditSubLessonVideo showPopup={showEditVideoPopup} setShowPopup={setShowEditVideoPopup} setRefreshVideoList={setRefreshVideoList} data={ediVideo} />
                )
            }

            {
                showAddQuizePopup && (
                    <AddQuize showPopup={showAddQuizePopup} setShowPopup={setShowAddQuizePopup} setRefreshQuizeList={setRefreshQuizeList} subLessonId={data?.id} />
                )
            }

            {
                showEditQuizePopup && (
                    <EditQuize showPopup={showEditQuizePopup} setShowPopup={setShowEditQuizePopup} setRefreshQuizeList={setRefreshQuizeList} data={editQuize} subLessonId={data?.id} />
                )
            }

            {
                showAddPracticePopup && (
                    <AddPractice showPopup={showAddPracticePopup} setShowPopup={setShowAddPracticePopup} setRefreshPracticeList={setRefreshPracticeList} subLessonId={data?.id} />
                )
            }

            {
                showEditPracticePopup && (
                    <EditPractice showPopup={showEditPracticePopup} setShowPopup={setShowEditPracticePopup} setRefreshPracticeList={setRefreshPracticeList} subLessonId={data?.id} data={editPractice} />
                )
            }

            {
                showAddImageFilePopup && (
                    <AddImageFile showPopup={showAddImageFilePopup} setShowPopup={setShowImageFilePopup} setRefreshImageFileList={setRefreshImageFileList} subLessonId={data?.id} />
                )
            }

            {
                showImagePreviewPopup && (
                    <ImagePreview showPopup={showImagePreviewPopup} setShowPopup={setShowImagePreviewPopup} imagePath={imagePath} />
                )
            }


            <DeletePopup />
            <ConfirmPopup />

            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={showCopySuccess}
                autoHideDuration={1000}
                onClose={handleClose}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    Copy to Clipboard.
                </Alert>
            </Snackbar>
        </>


    )
}